import i18 from '../../i18n';
import { PAGES } from '../pages';

export const retirementBusinessAccountMenu = [
  {
    title: i18.t('createAccount'),
    checked: true,
  },
  {
    title: i18.t('secureAccount'),
    path: PAGES.SECURE_ACCOUNT,
    nextPath: PAGES.SECURE_BUSINESS_NAME,
    previousPath: PAGES.BASE,
    items: [
      {
        title: i18.t('businessName'),
        path: PAGES.SECURE_BUSINESS_NAME,
        nextPath: PAGES.SECURE_NAME,
        previousPath: PAGES.SECURE_ACCOUNT,
      },
      {
        title: i18.t('yourName'),
        path: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_BUSINESS_NAME,
        preSkipPath: PAGES.SECURE_BUSINESS_NAME,
      },
      {
        title: i18.t('phoneNumber'),
        path: PAGES.SECURE_PHONE_NUMBER,
        previousPath: PAGES.SECURE_NAME,
        preSkipPath: PAGES.SECURE_NAME,
        nextPath: PAGES.SECURE_DOB,
      },
      {
        title: i18.t('dob'),
        path: PAGES.SECURE_DOB,
        nextPath: PAGES.SECURE_IDENTITY,
        previousPath: PAGES.SECURE_PHONE_NUMBER,
      },
      {
        title: i18.t('identityVerification'),
        path: PAGES.SECURE_IDENTITY,
        nextPath: PAGES.SECURE_IDENTITY_SSN,
        previousPath: PAGES.SECURE_DOB,
        skipPath: PAGES.ADDRESS,
        items: [
          {
            path: PAGES.SECURE_IDENTITY_SSN,
            nextPath: PAGES.SECURE_IDENTITY_DETAILS,
            previousPath: PAGES.SECURE_IDENTITY,
          },
          {
            path: PAGES.SECURE_IDENTITY_DETAILS,
            nextPath: PAGES.EMPLOYMENT_STATUS,
            previousPath: PAGES.SECURE_IDENTITY_SSN,
          },
        ],
      },
      {
        title: i18.t('employmentStatus'),
        path: PAGES.EMPLOYMENT_STATUS,
        previousPath: PAGES.SECURE_IDENTITY_DETAILS,
        nextPath: PAGES.FINANCIAL_PROFILE,
      },
      {
        title: i18.t('financialProfile'),
        path: PAGES.FINANCIAL_PROFILE,
        nextPath: PAGES.ADDRESS,
        previousPath: PAGES.EMPLOYMENT_STATUS,
        preSkipPath: PAGES.EMPLOYMENT_STATUS,
      },
    ],
  },
  {
    title: i18.t('address'),
    path: PAGES.ADDRESS,
    nextPath: PAGES.ADDRESS_ENTER,
    previousPath: PAGES.FINANCIAL_PROFILE,
    preSkipPath: PAGES.FINANCIAL_PROFILE,
    items: [
      {
        path: PAGES.ADDRESS_ENTER,
        nextPath: PAGES.ADDRESS_DONE,
        previousPath: PAGES.ADDRESS,
      },
      {
        path: PAGES.ADDRESS_DONE,
        nextPath: PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT,
        previousPath: PAGES.ADDRESS_ENTER,
      },
    ],
  },
  {
    title: i18.t('fund'),
    path: PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT,
    nextPath: PAGES.FUNDING.RETIREMENT_FUNDING.AMOUNT,
    previousPath: PAGES.ADDRESS_DONE,
    skipPath: PAGES.REVIEW,
    items: [
      {
        path: PAGES.FUNDING.RETIREMENT_FUNDING.AMOUNT.ROLLOVER,
        nextPath: PAGES.REVIEW,
        previousPath: PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT,
      },
      {
        path: PAGES.FUNDING.RETIREMENT_FUNDING.AMOUNT.ANNUAL_CONTRIBUTION,
        nextPath: PAGES.REVIEW,
        previousPath: PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT,
      },
    ],
  },
  {
    title: i18.t('review'),
    path: PAGES.REVIEW,
    nextPath: PAGES.EQUITY_AGREEMENT,
    previousPath: PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT,
    preSkipPath: PAGES.FUNDING.RETIREMENT_FUNDING.ACCOUNT,
    items: [
      {
        path: PAGES.EQUITY_AGREEMENT,
        nextPath: PAGES.AGREEMENT,
        previousPath: PAGES.REVIEW,
      },
      {
        path: PAGES.AGREEMENT,
        nextPath: '/',
        previousPath: PAGES.EQUITY_AGREEMENT,
      },
    ],
  },
];
